import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    sn: '',
    transientData: {},
    eventData: {},
    reqMode: 'uart', // udp（APP）, uart(网页)
    highSpdMode: false,
    freqSelectValue: 1,
    speedFreqSelectValue: 1
  },
  mutations: {
    updateToken (state, data) {
      state.token = data
    },
    updateSn (state, sn) {
      state.sn = sn
    },
    updateTransientData (state, transientData) {
      state.transientData = transientData
    },
    updateEventData (state, eventData) {
      state.eventData = eventData
    },
    updateSpeedMode (state, speed) {
      if (speed === '普通模式') {
        state.highSpdMode = false
      } else if (speed === '快速模式') {
        state.highSpdMode = true
      }
    },
    updateFreqSelectValue (state, freqSelectValue) {
      state.freqSelectValue = freqSelectValue
    },
    updateSpeedFreqSelectValue (state, speedFreqSelectValue) {
      state.speedFreqSelectValue = speedFreqSelectValue
    }
  },
  actions: {},
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js